// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2WlDZ","detailsBorder":"styles_detailsBorder__3VBsC"};